import React from 'react'

import { ConfirmModal } from '../../../shared/modal'
import useAppSettings from '../../../../lib/hooks/useAppSettings'

export type ConfirmDeleteGroupModalProps = {
  /** Disable the delete because the group still has items associated. */
  isDisabled?: boolean
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const defaultProps: Pick<ConfirmDeleteGroupModalProps, 'isDisabled'> = {
  isDisabled: false
}

const ConfirmDeleteGroupModal = ({
  isDisabled,
  isOpen,
  onConfirm
}: ConfirmDeleteGroupModalProps) => {
  const { text } = useAppSettings()
  const termLabel = text.term
  const advisorLabel = text.advisor
  const disabledMessage = `To delete a ${termLabel.toLowerCase()}, all items must be moved or deleted. If some items are locked or required, reach out to your ${advisorLabel.toLowerCase()}.`
  const enabledMessage = `Are you sure you want to delete the ${termLabel.toLowerCase()}?`

  return (
    <ConfirmModal
      confirmButtonDisabled={isDisabled}
      confirmText="Delete"
      isDanger
      isOpen={isOpen}
      onConfirm={onConfirm}
      title={`Delete ${termLabel}`}
    >
      {isDisabled ? disabledMessage : enabledMessage}
    </ConfirmModal>
  )
}

ConfirmDeleteGroupModal.defaultProps = defaultProps

export default ConfirmDeleteGroupModal
